import React from "react";

const QueueLayouts = () => <div className="content"><h2>Queue Layouts</h2></div>;

export default QueueLayouts; 